import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const toNumber = (value) => (value === '' || value == null ? null : Number(value));
// Referência Multibanco (RF-SLC20260926-007 / A13, RB-18): guarda-se sem espaços nem
// pontos para que o callback ifthenpay a compare por igualdade simples. Vazia → null
// (o campo é opcional; `NULL` = processo sem RefMB associada).
const toReferenciaMb = (value) => value == null || ('' + value).trim() === '' ? null : ('' + value).replace(/[\s.]/g, '');
const DialogFaturacaoProcesso = ({ open, initial, onClose }) => {
    const validationSchema = yup.object({
        faturaNome: yup.string().required('Nome é obrigatório'),
        faturaNif: yup.string().required('NIF é obrigatório'),
        faturaEmail: yup.string().email('Email inválido').notRequired(),
        faturaMorada: yup.string().required('Morada é obrigatória'),
        faturaContacto: yup.string().nullable(),
        faturaCep: yup.string().matches(/^\d{4}-\d{3}$/, 'Código Postal deve estar no formato XXXX-YYY').notRequired(),
        faturaLocalidade: yup.string().required('O campo é obrigatório').max(255, 'Limite de caracteres ultrapassado'),
        faturaConcelho: yup.string().required('Concelho é obrigatório'),
        faturaDistrito: yup.string().required('Distrito é obrigatório'),
        total: yup
            .number()
            .typeError('Total tem de ser um número')
            .test('is-decimal', 'Total tem de ter no máximo duas casas decimais', value => value == null || Number(value.toFixed(2)) - value === 0)
            .required('O campo é obrigatório'),
        totalProcesso: yup
            .number()
            .typeError('Total do Processo tem de ser um número')
            .test('is-decimal', 'Total do Processo tem de ter no máximo duas casas decimais', value => value == null || Number(value.toFixed(2)) - value === 0)
            .nullable()
            .notRequired(),
        // Validado sobre o valor normalizado, para aceitar a referência colada com
        // espaços/pontos (ex.: "046 2942 20"). Formato confirmado: 9 dígitos.
        referenciaMb: yup
            .string()
            .test('is-refmb', 'A Referência Multibanco tem de ter 9 dígitos', value => toReferenciaMb(value) == null || /^\d{9}$/.test(toReferenciaMb(value)))
            .nullable()
            .notRequired(),
    });
    const formik = useFormik({
        initialValues: initial ?? {},
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: (values) => onClose?.({
            ...(initial ?? {}),
            ...values,
            total: toNumber(values.total),
            totalProcesso: toNumber(values.totalProcesso),
            referenciaMb: toReferenciaMb(values.referenciaMb)
        }),
    });
    // useEffect(() => {
    //   formik.resetForm();
    //   formik.setValues(initial);
    // }, [initial]);
    return (<form>
      <Dialog open={open} maxWidth={'lg'} fullWidth>
        <DialogTitle>Editar Informação de Faturação</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Nome' name='faturaNome' value={formik.values?.faturaNome ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaNome && Boolean(formik.errors.faturaNome)} helperText={formik.touched.faturaNome && formik.errors.faturaNome}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={3} md={3} xs={12}>
              <TextField label='NIF' name='faturaNif' value={formik.values?.faturaNif ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaNif && Boolean(formik.errors.faturaNif)} helperText={formik.touched.faturaNif && formik.errors.faturaNif}/>
            </Grid>
            <Grid lg={3} md={3} xs={12}>
              <TextField label='Contacto' name='faturaContacto' value={formik.values?.faturaContacto ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaContacto && Boolean(formik.errors.faturaContacto)} helperText={formik.touched.faturaContacto && formik.errors.faturaContacto}/>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='Email' name='faturaEmail' value={formik.values?.faturaEmail ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaEmail && Boolean(formik.errors.faturaEmail)} helperText={formik.touched.faturaEmail && formik.errors.faturaEmail}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Morada' name='faturaMorada' value={formik.values?.faturaMorada ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaMorada && Boolean(formik.errors.faturaMorada)} helperText={formik.touched.faturaMorada && formik.errors.faturaMorada}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={3} md={2} xs={12}>
              <TextField label='Código Postal' name='faturaCep' value={formik.values?.faturaCep ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaCep && Boolean(formik.errors.faturaCep)} helperText={formik.touched.faturaCep && formik.errors.faturaCep}/>
            </Grid>
            <Grid lg={3} md={4} xs={12}>
              <TextField label='Localidade' name='faturaLocalidade' value={formik.values?.faturaLocalidade ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaLocalidade && Boolean(formik.errors.faturaLocalidade)} helperText={formik.touched.faturaLocalidade && formik.errors.faturaLocalidade}/>
            </Grid>
            <Grid lg={3} md={3} xs={12}>
              <TextField label='Concelho' name='faturaConcelho' value={formik.values?.faturaConcelho ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaConcelho && Boolean(formik.errors.faturaConcelho)} helperText={formik.touched.faturaConcelho && formik.errors.faturaConcelho}/>
            </Grid>
            <Grid lg={3} md={3} xs={12}>
              <TextField label='Distrito' name='faturaDistrito' value={formik.values?.faturaDistrito ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.faturaDistrito && Boolean(formik.errors.faturaDistrito)} helperText={formik.touched.faturaDistrito && formik.errors.faturaDistrito}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={3} md={4} xs={12}>
              <TextField label='Total a cobrar ao cliente' name='total' type='number' required value={formik.values?.total ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.total && Boolean(formik.errors.total)} helperText={formik.touched.total && formik.errors.total} inputProps={{ step: 0.01 }} InputProps={{ endAdornment: <InputAdornment position='end'>€</InputAdornment> }}/>
            </Grid>
            <Grid lg={3} md={4} xs={12}>
              <TextField label='Total do Processo' name='totalProcesso' type='number' value={formik.values?.totalProcesso ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.totalProcesso && Boolean(formik.errors.totalProcesso)} helperText={formik.touched.totalProcesso && formik.errors.totalProcesso} inputProps={{ step: 0.01 }} InputProps={{ endAdornment: <InputAdornment position='end'>€</InputAdornment> }}/>
            </Grid>
            <Grid lg={3} md={4} xs={12}>
              <TextField label='Referência Multibanco' name='referenciaMb' value={formik.values?.referenciaMb ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.referenciaMb && Boolean(formik.errors.referenciaMb)} helperText={(formik.touched.referenciaMb && formik.errors.referenciaMb) ||
            'Referência gerada no ifthenpay para este processo'}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </form>);
};
export default DialogFaturacaoProcesso;
